<template>
  <div class="w-full h-full">
    <google-map id="map"
                @click="mapClick"
                v-if="defaultMapOptions.center.lat"
                ref="Map" class="h-full" :options="defaultMapOptions" :center.sync="defaultMapOptions.center">
      <google-map-marker
        :position.sync="defaultMapOptions.center"
        v-if="defaultMapOptions.center.lat"
        @click="toggleInfoWindow()"
      />
      <google-map-infowindow
        :position="defaultMapOptions.center"
        :show.sync="showInfo"
        @info-window-clicked="infoClicked"
      >
        <h4>{{defaultMapOptions.title}}</h4>
        <p>{{defaultMapOptions.description}}</p>
      </google-map-infowindow>
    </google-map>
  </div>
</template>

<script>
export default {
  name: 'RestaurantMap',
  props: {
    restaurant_data: {
      type: Object
    }
  },
  data () {
    return {
      showInfo: false,
      defaultMapOptions: {
        zoom: 14,
        minZoom: 3,
        center: {
          lat: null,
          lng: null
        },
        title: '',
        description: '',
        streetViewControl: false,
        zoomControl:false,
        mapTypeControl: false
      }
    }
  },
  mounted () {
    this.defaultMapOptions.title = this.restaurant_data.name
    this.defaultMapOptions.description = this.restaurant_data.description

    const rest_location = JSON.parse(this.restaurant_data.user_property.Location)
    this.setMapLocation(rest_location)
  },
  methods: {

    setMapLocation (location) {
      this.defaultMapOptions.center = location
    },
    mapClick () {
      const urlSuffix = this.restaurant_data.user_property.Address
      window.open(
        'https://www.google.com/maps/search/?api=1&query='.concat(urlSuffix),
        '_blank'
      )
    },
    toggleInfoWindow () {
      this.showInfo = true
    },
    infoClicked () {
    }
  }
}
</script>

<style scoped>

</style>
